var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "sale-order-wrap" },
    [
      _c(
        "transition",
        { attrs: { name: "el-fade-in" } },
        [
          _c("orderSide", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isCollapse,
                expression: "isCollapse",
              },
            ],
            ref: "orderSide",
            on: { fetchData: _vm.fetchData },
          }),
        ],
        1
      ),
      _c("orderMain", { ref: "orderMain", on: { fetchData: _vm.fetchData } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }